module.exports = __webpack_public_path__ + "static/media/tratamentos.92edd4f8.jpg";